"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/InfoTab/PatientAppSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _relations = require('shared/selectors/user/relations');
var _patientApp = require('shared/selectors/patientApp');
var _Form = require('web/components/Form');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');





/* Settings › Organization › Patient app: "Patients can use the app", off
 * until an admin turns it on. Admins only: non-admins don't see it, and the server refuses
 * their changes. It saves on its own, like Translation. */
const PatientAppSection = ({ orgKey }) => {
  const isAdmin = _hooks.useAppSelector.call(void 0, state => _relations.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const isEnabled = _hooks.useAppSelector.call(void 0, state => _patientApp.selectIsPatientAppEnabled.call(void 0, state, orgKey))
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  // Guards against double submits; state alone lags a fast second click.
  const isSavingRef = _react.useRef.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const onChange = _react.useCallback.call(void 0, (enabled) => {
    if (isSavingRef.current) return
    isSavingRef.current = true
    setIsSaving(true)
    _actions2.default.updateOrgPatientAppSettings({ OrgKey: orgKey, Enabled: enabled })
      .then(() => showSuccessBar('Organization settings updated'))
      .catch(() => showWarningBar('Failed to update organization settings'))
      .finally(() => {
        isSavingRef.current = false
        setIsSaving(false)
      })
  }, [orgKey, showSuccessBar, showWarningBar])

  if (!isAdmin) return null

  return (
    _react2.default.createElement('section', { className: "settings--org-info--translation", 'aria-labelledby': "org-patient-app-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
      , _react2.default.createElement('h3', { id: "org-patient-app-title", className: "settings--org-info--translation--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Patient app"

      )
      , _react2.default.createElement('p', { className: "settings--org-info--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "Off until you turn it on. When it's on, your secure-link page invites patients to the BloomText app, and patients who use the app get your messages as app notifications instead of text links."

      )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--org-info--translation--toggle",
        label: "Patients can use the app"    ,
        hint: "While it's off, patients aren't invited to the app and keep getting text links and email. Patients who already use the app can still read and reply there."                           ,
        isChecked: isEnabled,
        isDisabled: isSaving,
        onChange: onChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PatientAppSection)
